import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { PRIMARY_FONT_COLOR, DISABLED_FONT_COLOR, TERTIARY_FONT_COLOR } from '../../../styles/fonts/MCFontConstants';

//Added autocomplete off as all inputs should not use browser prior entries
export const Input = styled.input.attrs((props) => ({
    autoComplete: 'off',
    autoFocus: props.autoFocus,
}))`
    border: ${({
        error,
        consignmentBillingBorder,
        equityBorder,
        shiptoAddress,
        isBorderColor,
    }) =>
        error
            ? '2px solid #ff0000'
            : equityBorder
            ? '1px solid #rgba(0, 0, 0, 0.23)'
            : shiptoAddress
            ? '1px solid #ced4da'
            : consignmentBillingBorder
            ? consignmentBillingBorder
            : isBorderColor
            ? '1px solid #4f4f4f59'
            : '2px solid #ebeded'};
    border-radius: ${({ borderRadius }) =>
        borderRadius ? borderRadius : '6px'};
    background: ${({ backgroundDisabled, backgroundInactive }) =>
        backgroundDisabled
            ? '#F1F1F1'
            : backgroundInactive
            ? backgroundInactive
            : '#ffffff 0% 0% no-repeat padding-box'};
    height: ${({ height }) => (height ? height : '40px')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '16px')};
    width: ${({ width }) => (width ? width : '100%')};
    font-family: AvenirNextWorld Regular;
    padding-left: 10px;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    margin-top: ${({ marginTop }) =>
        marginTop ? marginTop : ''};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    opacity: ${({ disabled }) => (disabled ? 0.75 : 1)};
    outline: none;
    color: ${({ disabled }) => !disabled && PRIMARY_FONT_COLOR };
    ::placeholder {
        opacity: ${({ disabled, placeHolderOpacity }) =>
            disabled ? 0.8 : placeHolderOpacity ? placeHolderOpacity : 0.5};
        color: ${TERTIARY_FONT_COLOR};
    }
    &:focus-visible {
        outline: white;
    }
    ${media.smalDevice`
        width: ${({ ipadWidth, width }) =>
            ipadWidth ? ipadWidth : width ? width : '100%'};
    `};
    ${media.ipadAir`
        width: ${({ ipadAirWidth }) => (ipadAirWidth ? ipadAirWidth : '')};
        margin-left: ${({ ipadAirMarginLeft }) => (ipadAirMarginLeft ? ipadAirMarginLeft : '0px')};
    `};
    ${media.mediumDevice`
        width: ${({ ipadProWidth }) => (ipadProWidth ? ipadProWidth : '')};
        margin-left: ${({ ipadProMarginLeft }) => (ipadProMarginLeft ? ipadProMarginLeft : '0px')};
    `};
    @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait){
     margin-left: ${({ ipadMarginLeft }) => (ipadMarginLeft ? ipadMarginLeft : '0px')};

    }
    ${media.mobileDevice`
        width: ${({ widthMob }) => (widthMob ? widthMob : '100%')};
        margin-left: ${({ mobMarginLeft }) => (mobMarginLeft ? mobMarginLeft : '0px')};
        outline: none;
        margin-right:  ${({ mbMarginRight }) =>
            mbMarginRight ? mbMarginRight : ''};
        border-radius: ${({ mbBorderRadius }) =>
            mbBorderRadius ? mbBorderRadius : ''};
    `};
    @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait) {
        width: ${({ iPadmini, fromConsignmentBilling }) =>
            iPadmini && !fromConsignmentBilling ? '50%' : ''};
        margin-left: ${({ iPadminiMarginLeft }) =>
            iPadminiMarginLeft ? iPadminiMarginLeft : ''};
         margin-right: ${({ iPadminiMarginRight }) =>
            iPadminiMarginRight ? iPadminiMarginRight : ''};
 
    }
    &:hover {
        border: 1px solid #000; /* Change this to your desired hover border color */
    }
    &:disabled {
        color: ${DISABLED_FONT_COLOR};
    }
`;

export const PasswordInput = styled.input.attrs(() => ({
    type: 'password',
}))`
    border: 2px solid #ebeded;
    border-radius: 6px;
    background: #ffffff 0% 0% no-repeat padding-box;
    height: 40px;
    font-size: 16px;
    width: ${({ width }) => (width ? width : '100%')};
    font-family: AvenirNextWorld Regular;
    padding-left: 10px;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    &:focus-visible {
        outline: white;
    }
    ${media.mobileDevice`
    margin-left: 0px;
    `};
`;
export const Label = styled.label`
    color: black;
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
`;
